<template>
  <b-modal
    v-model="showModal"
    title="MR Details"
    size="lg"
    @hidden="$emit('modal-closed')"
  >
    <b-alert
      variant="danger"
      :show="errorMessage ? true : false"
    >
      <div
        v-if="typeof errorMessage === 'object'"
        class="alert-body"
      >
        <p
          v-for="(message, index) in errorMessage"
          :key="index"
        >
          {{ message }}
        </p>
      </div>
      <p
        v-else
        class="alert-body"
      >
        {{ errorMessage }}
      </p>
    </b-alert>

    <div
      v-if="loading"
      class="text-center"
    >
      <b-spinner
        label="Small Spinner"
        variant="primary"
      />
    </div>
    <div v-if="!loading && !errorMessage">
      <b-table-simple
        responsive
        hover
        class="compact-table"
      >
        <b-tbody>
          <b-tr>
            <b-th>Name:</b-th>
            <b-td>
              {{ details.name }}
            </b-td>
            <b-th>Status:</b-th>
            <b-td>
              <app-chip :variant="getStatusChipVariant(details.is_active)">
                {{ details.is_active ? 'Active' : 'Inactive' }}
              </app-chip>
            </b-td>
          </b-tr>
          <b-tr>
            <b-th>Company : </b-th>
            <b-td>
              &nbsp;{{ details.company_name }}
            </b-td>
            <b-th>Post:</b-th>
            <b-td>
              {{ details.post }}
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <!-- Mobile Numbers Section -->
      <div
        v-if="details.mr_mobiles && details.mr_mobiles.length > 0"
        class="mt-1"
      >
        <b-table-simple
          responsive
          hover
          class="compact-table"
        >
          <b-thead>
            <b-tr>
              <b-th>Mobile Number</b-th>
              <b-th>WhatsApp</b-th>
              <b-th>Primary</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="mobile in details.mr_mobiles"
              :key="mobile.id"
            >
              <b-td>
                <a
                  :href="`tel:${mobile.mobile}`"
                  class="text-primary"
                >
                  {{ mobile.mobile }}
                </a>
              </b-td>
              <b-td>
                <span
                  v-if="mobile.is_whatsapp"
                  class="text-success"
                >
                  ✓
                </span>
              </b-td>
              <b-td>
                <span
                  v-if="mobile.is_primary"
                  class="text-success"
                >
                  ✓
                </span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>

      <!-- Email Addresses Section -->
      <div
        v-if="details.mr_emails && details.mr_emails.length > 0"
        class="mt-1"
      >
        <b-table-simple
          responsive
          hover
          class="compact-table"
        >
          <b-thead>
            <b-tr>
              <b-th>Email Address</b-th>
              <b-th>Primary</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr
              v-for="email in details.mr_emails"
              :key="email.id"
            >
              <b-td>
                <a
                  :href="`mailto:${email.email}`"
                  class="text-primary"
                >
                  {{ email.email }}
                </a>
              </b-td>
              <b-td>
                <span
                  v-if="email.is_primary"
                  class="text-success"
                >
                  ✓
                </span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
    </div>

    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="secondary"
        @click="cancel()"
      >
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BSpinner, BButton, BAlert, BTableSimple, BTr, BTh, BTd, BTbody, BThead,
} from 'bootstrap-vue'
import axios from 'axios'
import dateMixin from '@/mixins/dateMixin'
import AppChip from '../../UI/AppChip.vue'

export default {
  components: {
    BModal,
    BButton,
    BSpinner,
    BAlert,
    BTableSimple,
    BTr,
    BTh,
    AppChip,
    BTd,
    BTbody,
    BThead,
  },
  mixins: [dateMixin],
  props: {
    id: { type: Number, required: true },
  },
  data() {
    return {
      showModal: true,
      details: {},
      loading: true,
      errorMessage: '',
      readOnly: false,
    }
  },
  mounted() {
    this.fetchDetails()
  },
  methods: {
    async fetchDetails() {
      try {
        this.loading = true
        const { data } = await axios.get(`/mr/${this.id}`)
        this.details = data
      } catch (error) {
        this.errorMessage = error?.response?.data?.detail || 'Failed to fetch MR details'
      } finally {
        this.loading = false
      }
    },
    getStatusChipVariant(isActive) {
      return isActive ? 'success' : 'danger'
    },
  },
}
</script>

<style scoped>
label {
  display: block;
  font-weight: 500;
  margin: 0;
  padding: 0;
}
td {
  text-align: start;
  margin: 0;
  padding: 5px;
}
th {
  width: 55px;
  margin: 0;
  padding: 0;
}
h6 {
  font-weight: 600;
  color: #495057;
  margin: 0;
  padding: 0;
}
.compact-table {
  margin: 0;
  padding: 0;
}
.text-success {
  font-size: 1.2rem;
  font-weight: bold;
}
</style>
